import React, { Component } from 'react';
import { Button, Form, Label, Input, Row, Col, ButtonGroup } from 'reactstrap';
import Header from './HeaderComponent';
import {graphs} from '../shared/graphs';

class BFS extends Component{
    constructor(props){
        super(props);
        this.state={
            graph: graphs[0]
        }
        this.HandleStartingNode = this.HandleStartingNode.bind(this);
        this.reset = this.reset.bind(this);
    }
    reset(){
        this.state.graph.nodes.map((node) => document.getElementById(node.id).style.fill = "red");
        this.state.graph.edges.map((edge) => document.getElementById(edge.id).style.stroke = "#006400");
    }
    sleep(ms) {
        return new Promise(
          resolve => setTimeout(resolve, ms)
        );
    }
    async BFS(network, startNode){
        var queue = [startNode];
        var parent = [];
        for(var i=0; i<network.length; i++){
            parent.push(null);
        }
        parent[startNode] = startNode;
        var node, node_id, edge_id;
        while(queue.length!==0){
            node = queue.shift()
            node_id = "n"+(node+1);
            document.getElementById(node_id).style.fill = "blue";
            await this.sleep(1000);
            for( i = 0; i<network[node].length; i++){
                if(network[node][i] !== 0 && parent[i] === null){
                    if(node<i){
                        edge_id = (node+1)+"to"+(i+1);
                    }
                    else{
                        edge_id = (i+1)+"to"+(node+1);
                    }
                    document.getElementById(edge_id).style.stroke = "#FF4500";
                    await this.sleep(1000);
                    queue.push(i);
                    parent[i] = node;
                }
            }
        }
    }
    HandleStartingNode(event){
        var requiredNode = this.state.graph.nodes.filter((node) => node.text === parseInt(this.startNode.value))[0];
        this.BFS(this.state.graph.network, requiredNode.text - 1);
        event.preventDefault();
    }
    
    render(){ 
        const renderEdges = this.state.graph.edges.map((edge)=>{
            return(
                <line id={edge.id} x1={edge.x1} y1={edge.y1} x2={edge.x2} y2={edge.y2} stroke="#006400" stroke-width="3" />
            );
        });
        const renderNodes = this.state.graph.nodes.map((node) => {
            return(
                <>
                    <circle id={node.id} cx={node.cx} cy={node.cy} r="20" stroke="black" stroke-width="3" fill="red"/>
                    <text id={node.textId} x={node.cx} y={node.cy} text-anchor="middle" stroke="#ffffff" stroke-width="1px" dy=".3em">{node.text}</text>
                </>
            );
        });
        return(
            <>
                <Header destination="Breadth First Search"/>
                <div className="container">
                    <div className="p-2 border black-yellow mb-2">
                        <div className="row mb-2 mt-2">
                            <div className="col-12">
                                <h4>Introduction to BFS</h4>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-12">
                                <p>The Breadth First Search (BFS) traversal is an algorithm, which is used to visit all of the nodes of a given graph. In this traversal algorithm one node is selected and then all of the adjacent nodes are visited one by one. After completing all of the adjacent vertices, it moves further to check another vertices and checks its adjacent vertices again.</p>
                                <p>To implement this algorithm, we need to use the Queue data structure. All the adjacent vertices are added into the queue, when all adjacent vertices are completed, one item is removed from the queue and start traversing through that vertex again.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-12 text-center">
                            <ButtonGroup>
                                <Button onClick={() => {
                                    this.setState({graph: graphs[0]});
                                    this.reset();
                                    }}>1</Button>
                                <Button onClick={() => {
                                    this.setState({graph: graphs[1]});
                                    this.reset();
                                    }}>2</Button>
                                <Button onClick={() => {
                                    this.setState({graph: graphs[2]});
                                    this.reset();
                                    }}>3</Button>
                            </ButtonGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <svg height="500" width="500">
                                {renderEdges}
                                {renderNodes}
                            </svg>
                        </div>
                        <div className="col-12 col-md-6">
                            <Form onSubmit={this.HandleStartingNode}>
                                <Row className="form-group">
                                    <Col md={2}>
                                        <Label htmlFor="size">Enter Starting Node</Label>
                                    </Col>
                                    <Col md={6}>
                                        <Input required type="number" id="startnode" name="startnode" innerRef={(input) => this.startNode = input}/>
                                    </Col>
                                    <Col md={2}>
                                        <Button color="primary" type="submit">Start BFS</Button>
                                    </Col>
                                </Row>
                            </Form>
                            <Button onClick={this.reset} color="danger">Reset Graph</Button>
                        </div>
                    </div>
                    
                </div>
            </>
        );
    }
}

export default BFS;